/* Enhance Shopify's native POST form; the submit buttons also work without JS. */
document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.classList.contains('fw-language-form')) return;
  const returnTo = form.querySelector('input[name="return_to"]');
  if (returnTo) returnTo.value = location.pathname + location.search + location.hash;
  const languageButton = event.submitter;
  if (languageButton?.name === 'language_code' && languageButton.form === form) {
    try { localStorage.setItem('fw-language-choice', languageButton.value); } catch (_) {}
  }
});

// Native details remains usable without JavaScript, including keyboard opening.
document.addEventListener('click', (event) => {
  document.querySelectorAll('.fw-language-switcher[open]').forEach((switcher) => {
    if (!switcher.contains(event.target)) switcher.open = false;
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.fw-language-switcher[open]').forEach((switcher) => {
    const hadFocus = switcher.contains(document.activeElement);
    switcher.open = false;
    if (hadFocus) switcher.querySelector('summary').focus();
  });
});

document.addEventListener('focusin', (event) => {
  document.querySelectorAll('.fw-language-switcher[open]').forEach((switcher) => {
    if (!switcher.contains(event.target)) switcher.open = false;
  });
});
